/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import {getMode} from '@dvrd/dvr-controls';

const prodMode = (): boolean => getMode() === 'prod';

export const setGaUserId = (id: string | null) => {
    if (prodMode() && window.gtag) {
        if (id)
            window.gtag('set', {'user_id': id});
        else window.gtag('set', {'user_id': ''});
    }
};

export const sendGaPageView = (path?: string) => {
    if (prodMode() && window.gtag) {
        const trackingId = getTrackingID();
        if (trackingId) {
            const pathConfig: { page_path?: string; page_location: string; page_title: string } = {
                page_location: window.location.href,
                page_title: document.title,
            };
            if (path && path.length) {
                if (!path.startsWith('/')) path = `/${path}`;
                pathConfig.page_path = path;
            }
            window.gtag('event', 'page_view', pathConfig);
        }
    }
};

export const sendGaEvent = (action: string, category?: string, label?: string, value?: string) => {
    if (prodMode() && getTrackingID() && window.gtag)
        window.gtag('event', action, {event_category: category, event_label: label, value, send_to: getTrackingID()});
};

const getTrackingID = (): string | null => {
    return window.allowCookies && prodMode() ? window.settings.gaID : null;
};

export function signUpEvent(method: 'Google' | 'Manual') {
    sendGaEvent('sign_up', method);
}

export function paymentInfoEvent() {
    sendGaEvent('add_payment_info');
}